import { commonService } from '.';
import axios from "axios";

const APIURL = process.env.PUBLIC_URL + "/api";

const insertSkillsEvaluation = (body) => {
    return commonService.post('SkillsEvaluation', body);
};

const getValidateDCSkill = (body) => {
    return commonService.getWithParam('SkillsEvaluation/technique', body);
};

const deleteSkillsEvaluation = (id, idEa) => {
    return commonService.deleteWithParam('SkillsEvaluation?id=' + id + '&idEa=' + idEa, null);
};

const updateALotSkillsEvaluationAsync = async (body) => {
    const endpoint = 'SkillsEvaluation';
    const url = `${APIURL}/` + endpoint;
    return await axios.put(url, body);
};

const isEaSkillsDataValid = async (idEa) => {
    const endpoint = 'SkillsEvaluation/checkData?idEa=' + idEa;
    const url = `${APIURL}/` + endpoint;
    return await axios.get(url, { params: null });
};

const insertALotSkillsEvaluation = (body) => {
    return commonService.post('SkillsEvaluation/insertALot', body);
};

const getEaSkillData = (request, idSkillCategoryType) => {
    let idUser = request.idUser;
    let year = request.year;
    let idLang = request.idLang;
    return commonService.getWithParam('SkillsEvaluation/eaSkills?idUser=' + idUser + '&year=' + year + '&idLang=' + idLang + '&idSkillCategoryType=' + idSkillCategoryType, null);
};

const updateEaSkillData = (body, idUser, idEa) => {
    return commonService.put('SkillsEvaluation/eaSkills?idUser=' + idUser + '&idEa=' + idEa, body);
};

export const skillsEvaluation = {
    getValidateDCSkill,
    insertSkillsEvaluation,
    deleteSkillsEvaluation,
    updateALotSkillsEvaluationAsync,
    isEaSkillsDataValid,
    insertALotSkillsEvaluation,
    getEaSkillData,
    updateEaSkillData
};